export enum ActionType {
  RESET_TEAM = 'RESET_TEAM',
  INVITE_MANAGER = 'INVITE_MANAGER',
  INVITE_CLIENT_MANAGER = 'INVITE_CLIENT_MANAGER',
  ASSIGN_MANAGER = 'ASSIGN_MANAGER',
  GET_TEAM = 'GET_TEAM',
  SET_TEAM = 'SET_TEAM',
  DELETE_ACCESS_TO_CLIENT = 'DELETE_ACCESS_TO_CLIENT',
  DELETE_ACCESS_TO_CENTRA = 'DELETE_ACCESS_TO_CENTRA',
  GET_MANAGER_PROFILE = 'GET_MANAGER_PROFILE',
  SET_MANAGER_PROFILE = 'SET_MANAGER_PROFILE',
}

export interface IDeleteAccessToClient {
  managerId: number
  managerName?: string
  clientId?: number
  clientName?: string
}

export interface IDeleteAccessToCentra {
  managerId: number
  isOpen: boolean | undefined
}

export interface IInviteTeam {
  managerEmail: string
  clientId: number[]
}

export interface IAssignManager {
  managerId: number
  clientId: number[]
  amountOfNewClients?: number
}

export interface IInviteClientManager {
  email: string
  page?: 'team'
}

export interface ITeamClient {
  id: number
  name: string
  logo: string
  archivedBy: number
}

export interface ITeamMember {
  id: number
  firstName: string
  lastName: string
  avatar?: string
  mobilePhone?: string
  active: boolean | undefined
  email: string
  title: string | null
}

export interface ITeamMemberRow extends ITeamMember {
  clients: ITeamClient[]
}
